import { render, staticRenderFns } from "./StudentTracking.vue?vue&type=template&id=010c5bd5&scoped=true&"
import script from "./StudentTracking.vue?vue&type=script&lang=js&"
export * from "./StudentTracking.vue?vue&type=script&lang=js&"
import style0 from "./StudentTracking.vue?vue&type=style&index=0&id=010c5bd5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "010c5bd5",
  null
  
)

export default component.exports